import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { QUERY_KEYS } from '@/utils/query-keys';
import { AttachmentReportService } from '@/infra/services/attachment';

interface DestroyAttachmentParams {
	organization_id: string;
	company_id: string;
	id: string;
}

const Service = AttachmentReportService.getInstance();

export function useDestroyAttachment() {
	const queryClient = useQueryClient();
	return useMutation((params: DestroyAttachmentParams) => Service.destroyAttachment(params), {
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_ATTACHMENT_LIST]);
			message.success(I18n.get('Attachment deleted successfully'));
		},
		onError: () => {
			message.error(I18n.get('Error on delete attachment'));
		}
	});
}
